import React from "react";
import {Avatar} from '@material-ui/core';
import {getColor, getLabel} from "./codes";
import {Link} from "react-router-dom";

const numberWithCommas = (num) => {
  const _num = !num ? '0' : (typeof num === 'number' ? num.toString() : num)
  return _num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const join = (joiner = ", ") => cellContent => (`${cellContent.map(c => c.label).join(joiner)}`);
export const count = cellContent => cellContent ? numberWithCommas(cellContent) : 0;
export const price = cellContent => <>₩ {numberWithCommas(cellContent)}</>;
export const date = cellContent => cellContent ? cellContent.split(" ")[0] : '-';
export const dateTime = cellContent => cellContent || '-';
export const category = (cellContent, row) => <>{`${row.catNm1} > ${row.catNm2}`}</>;
export const calculator = predicate => (cellContent, margin) => predicate(cellContent, margin);
export const label = group => cellContent => <>{getLabel(group, cellContent)}</>;

export const dot = group => cellContent => (
  <>
    <span className={`label label-${getColor(group, cellContent)} label-dot mr-2`}/>
    <span className={`font-weight-bold text-${getColor(group, cellContent)}`}>
      {getLabel(group, cellContent)}
    </span>
  </>
);

export const chip = group => cellContent => (
  <span className={`label label-lg font-weight-bold label-${getColor(group, cellContent)} label-inline px-10`}>
    {getLabel(group, cellContent)}
  </span>
);

export const prodName = (cellContent, row) => (
  <div className="d-flex align-items-center">
    <Avatar src={row.imgUrl} variant="rounded">{cellContent.split("").shift()}</Avatar>
    <div className="ml-3">
      <span className="text-dark-75 font-weight-bold line-height-sm d-block pb-2 break-all max-w-120 min-w-80px">
        {cellContent}
      </span>
    </div>
  </div>
);

export const goodsListOpt = content => {
  return content ? (
    <p className="mb-0 keep-all w-200px" style={{maxWidth: 300}}>
      {content.split('/').join(" / ") || '-'}
    </p>
  ) : '-';
};

export const goodsDetailOpt = cellContent => cellContent ? (
  <>
    {cellContent.map(opt => (
      <p className="m-0" key={opt.optNo}>
        {opt.optNm}{" - "}
        {opt.optDtlList.map(sub => sub.optDtlNm).join(', ')}
      </p>
    ))}
  </>
) : null;

export const detailModalOptions = (cellContent) => (
  cellContent && cellContent.map(({optNm, ordQty}, index) => (
    <span key={`options-${index}`}>
      <span key={`opt-${index}`}>{!!index && ", "}{optNm}/{ordQty}</span>
    </span>
  ))
);

export const user = content => {
  switch(content) {
    case '02':
      return <span>공급 파트너</span>;
    case '03':
      return <span>판매 파트너</span>;
    default:
      return <span>-</span>;
  }
}

export const link = link => (content, row) => (
  <Link to={`${link}/${row.goodsNo}`} className={`font-weight-bold label-inline`}>
    {content}
  </Link>
);

export const agree = (bool, name) => (
  <div>
    <span className={`label label-md ${bool ? 'label-light-success' : 'label-light-danger'} label-inline mr-3`}>
      {bool ? '동의' : '비동의'}
    </span>
    {name}
  </div>
);

